import Vue from 'vue'
import Vuex from 'vuex'

import axios from '@/axiosConnection'
import toastr from '@/toastr'

import auth from './modules/auth';
import warehouse from './modules/warehouse';
import storage_zone from './modules/storage_zone';
import storage_environment from './modules/storage_environment';
import storage_type from './modules/storage_type';
import company from './modules/company';
import company_contact from './modules/company_contact';
import company_group from './modules/company_group';
import company_type from './modules/company_type';
import calibration from './modules/calibration';
import certificate from './modules/certificate';
import equipment_group from './modules/equipment_group';
import equipment_type from './modules/equipment_type';
import maintenance from './modules/maintenance';
import price_type from './modules/price_type';
import price from './modules/price';
import reference_log from './modules/reference_log';
import reference from './modules/reference';
import spare_part from './modules/spare_part';
import status from './modules/status';
import product from './modules/product';
import order from './modules/order';
import productfamily from './modules/product_family';
import agency from './modules/agency';
import user from './modules/user';
import entity from './modules/entity';
import imputation from './modules/imputation';
import vehicle from './modules/vehicle';
import group from './modules/group';
import search from './modules/search';
import photos from './modules/photo';
import documents from './modules/document';
import specifications from './modules/specification';

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    auth: auth,
    warehouse: warehouse,
    storage_zone: storage_zone,
    storage_environment: storage_environment,
    storage_type: storage_type,
    company: company,
    company_contact: company_contact,
    company_group: company_group,
    company_type: company_type,
    calibration: calibration,
    certificate: certificate,
    equipment_group: equipment_group,
    equipment_type: equipment_type,
    maintenance: maintenance,
    price_type: price_type,
    price: price,
    reference_log: reference_log,
    reference: reference,
    spare_part: spare_part,
    status: status,
    product: product,
    productfamily: productfamily,
    order: order,
    user: user,
    agency: agency,
    entity: entity,
    imputation: imputation,
    vehicle: vehicle,
    group: group,
    search: search,
    photos: photos,
    documents: documents,
    specifications: specifications
  },
  state: {
    menu: '',
    loader: true,
    loaderCart: false,
    searchState: '',
    homeSearchState: '',
    user: []
  },
  mutations: {
    toggleMenu(state) {
      state.menu = state.menu == 'active' ? '' : 'active';
    },
    toggleSearch(state) {
      state.searchState = state.searchState == 'active' ? '' : 'active';
    },
    showSearch(state){
      state.searchState = 'active';
    },
    hideSearch(state){
      state.searchState = '';
    },
    showHomeSearch(state){
      state.homeSearchState = 'active';
    },
    hideHomeSearch(state){
      state.homeSearchState = '';
    },
    showLoader(state) {
      state.loader = true
    },
    hideLoader(state) {
      state.loader = false
    },
    showCartLoader(state) {
      state.loaderCart = true
    },
    hideCartLoader(state) {
      state.loaderCart = false
    },
    setItems(state, params) {
      if (params.items) {
        state[params.namespace].items = params.items
      }
    },
    setItem(state, params) {
      if (params.item) {
        state[params.namespace].items.splice(state[params.namespace].items.findIndex(i => i.id == params.item.id), 1, params.item)
      }
    },
    addItem(state, params) {
      state[params.namespace].items.unshift(params.item)
    },
    saveItem(state, params) {
      state[params.namespace].items.splice(state[params.namespace].items.findIndex(i => i.id == params.item.id), 1, params.item)
    },
    deleteItem(state, params) {
      state[params.namespace].items = state[params.namespace].items.filter(item => item.id != params.id);
    }
  },
  getters: {
    menuState: state  => state.menu,
    searchState: state  => state.searchState,
    homeSearchState: state  => state.homeSearchState,
    loaderState: state => state.loader,
    loaderCartState: state => state.loaderCart,
    getUser: state => state.user
  },
  actions: {
    /**
     * Charge tous les items via l'API dans le state. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param object                  Paramètres
     *        boolean   wait          Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     *        string    api_url       Chemin racine de l'url à appeler
     *        string    api_data_path Chemain objet des données à charger dans le retour API
     *        string    namespace     Espace de nom du module store à l'origine de l'appel
     * @returns promise               Aucune donnée n'est retournée
     */
    getAll: (context, params) => {
      return new Promise(function (resolve, reject) {
        if (params.wait == false && context.state[params.namespace].items && context.state[params.namespace].items.length) {
          resolve()
        }
        axios.get(params.api_url + "?limit=0")
          .then(response => {
            let p = {
              items: response.data[params.api_data_path],
              namespace: params.namespace
            }
            context.commit('setItems', p)
            resolve()
          })
          .catch(error => {
            toastr.error("Le chargement de la liste a échoué")
            reject()
          })
      })
    },
    /**
     * Charge un seul item via l'API dans le state. Si la donnée est déjà présente dans le state, le résolve() est lancé de suite
     * @param {object}                  Paramètres
     *        {boolean}   wait          Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     *        {string}    api_url       Chemin racine de l'url à appeler
     *        {string}    namespace     Espace de nom du module store à l'origine de l'appel
     *        {integer}   id            Id de l'item à charger
     * @returns promise                 Aucune donnée n'est retournée
     */
    getItem: (context, params) => {
      return new Promise(function (resolve, reject) {
        if (params.wait == false && context.state[params.namespace].items && context.state[params.namespace].items.length && context.state[params.namespace].items.find(item => item.id == params.id)) {
          resolve()
        }
        axios.get(params.api_url + "/" + params.id)
          .then(response => {
            let p = {
              item: response.data,
              namespace: params.namespace
            }
            context.commit('setItem', p)
            resolve()
          })
          .catch(error => {
            toastr.error("Le chargement de la liste a échoué")
            reject()
          })
      })
    },
    toggleMenu: (context) => {
      context.commit('toggleMenu')
    },
    toggleSearch: (context) => {
      context.commit('toggleSearch')
    },
    showSearch: (context) => {
      context.commit('showSearch')
    },
    hideSearch: (context) => {
      context.commit('hideSearch')
    },
    showHomeSearch: (context) => {
      context.commit('showHomeSearch')
    },
    hideHomeSearch: (context) => {
      context.commit('hideHomeSearch')
    },
    showLoader: (context) => {
      context.commit('showLoader')
    },
    hideLoader: (context) => {
      context.commit('hideLoader')
    },
    showCartLoader: (context) => {
      context.commit('showCartLoader')
    },
    hideCartLoader: (context) => {
      context.commit('hideCartLoader')
    },
    /**
     * Ajoute un item dans le state et via l'API.
     * @param object                  Paramètres
     *        string    api_url       Chemin racine de l'url à appeler
     *        string    namespace     Espace de nom du module store à l'origine de l'appel
     *        object    item          Item à créer
     *        object    formData      formData si souhaité, il sera alors envoyé à la place de item
     * @returns promise               Aucune donnée n'est retournée
     */
    addItem(context, params) {
      return new Promise(function (resolve, reject) {
        let p = {
          item: params.item,
          namespace: params.namespace
        }
        context.commit('addItem', p)

        let data = params.formData || params.item

        axios.post(params.api_url, data)
          .then(reponse => {
            toastr.success("L'ajout s'est déroulé avec succès");
            context.dispatch(params.namespace + '/getAll')
            resolve(reponse)
          })
          .catch(error => {
            toastr.error("La création a échoué")
            context.dispatch(params.namespace + '/getAll')
            reject(error)
          })
      })
    },
    /**
     * Met à jour un item dans le state et via l'API.
     * @param object                  Paramètres
     *        string    api_url       Chemin racine de l'url à appeler
     *        string    namespace     Espace de nom du module store à l'origine de l'appel
     *        object    item          Item à mettre à jour (doit contenir une propriété 'id')
     *        object    formData      formData si souhaité, il sera alors envoyé à la place de item
     * @returns promise               Aucune donnée n'est retournée
     */
    saveItem(context, params) {
      return new Promise(function (resolve, reject) {
        let p = {
          item: params.item,
          namespace: params.namespace
        }
        context.commit('saveItem', p)

        let data = params.formData || params.item

        axios.patch(params.api_url + '/' + params.item.id, data)
          .then(response => {
            toastr.success("L'enregistrement s'est déroulé avec succès");
            context.dispatch(params.namespace + '/getAll')
            resolve(response)
          })
          .catch(error => {
            toastr.error("L'enregistrement a échoué")
            context.dispatch(params.namespace + '/getAll')
            reject(error)
          })
      })
    },
    /**
     * Supprime un item du state et via l'API.
     * @param object                  Paramètres
     *        string    api_url       Chemin racine de l'url à appeler
     *        string    namespace     Espace de nom du module store à l'origine de l'appel
     *        integer   id            Id de l'item à supprimer
     * @returns promise               Aucune donnée n'est retournée
     */
    deleteItem(context, params) {
      return new Promise(function (resolve, reject) {
        let p = {
          id: params.id,
          namespace: params.namespace
        }
        context.commit('deleteItem', p)
        axios.delete(params.api_url + '/' + params.id)
          .then(response => {
            toastr.success("La suppression s'est déroulée avec succès");
            context.dispatch(params.namespace + '/getAll')
            resolve(response)
          })
          .catch(error => {
            toastr.error("La suppression a échoué")
            context.dispatch(params.namespace + '/getAll')
            reject(error)
          })
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/stores/index.js